var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCountDownFrame = function SvgCountDownFrame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 116,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#count-down-frame_svg__a)",
    filter: "url(#count-down-frame_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#count-down-frame_svg__c)",
    d: "M70.548.211H6.452A2.245 2.245 0 0 0 4.21 2.458v103.014a2.245 2.245 0 0 0 2.242 2.247h64.096a2.245 2.245 0 0 0 2.242-2.247V2.458A2.245 2.245 0 0 0 70.548.211"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M70.548 108H6.452A2.49 2.49 0 0 1 4 105.542V2.458A2.49 2.49 0 0 1 6.452 0h64.096A2.49 2.49 0 0 1 73 2.458v103.084A2.49 2.49 0 0 1 70.548 108M6.452.421a2.035 2.035 0 0 0-2.031 2.036v103.084a1.96 1.96 0 0 0 1.961 1.966h64.166a1.96 1.96 0 0 0 1.961-1.966V2.458A1.96 1.96 0 0 0 70.548.492H6.452v-.07z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "count-down-frame_svg__c",
    x1: 38.535,
    x2: 38.535,
    y1: 1.054,
    y2: 107.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c9c9c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "count-down-frame_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 0h69v108H4z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "count-down-frame_svg__b",
    width: 77,
    height: 116,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "A"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "B",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "B",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "A"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic"
  })))));
};
export default SvgCountDownFrame;